/* eslint-disable max-lines */

export const MAX_CITY_LIST_VIEW_STORES = 10
export const MIN_POI_LIST_VIEW_STORES = 3
export const MAX_POI_LIST_VIEW_STORES = 10
export const HIGH_RATING = 4.5

export const STORE_TYPES = [
  "Locker",
  "The UPS Store",
  "Retail Store",
  "Hotel",
  "Convenience Store",
  "Restaurant",
  "Cafe",
  "Shipping Store",
  "Office",
  "Luggage Storage",
]
